import { computed, signal } from '@preact/signals-react';
import { ConfigurationResponse } from '../models/configuration';
import { VirtualFileSystemType } from '../models/files';
import { Basis, IsacSession } from '../types';
import LocalStorage from './LocalStorage';

export type StateType = {
  status: 'idle' | 'loading' | 'error' | 'success';
  isLoggedIn: boolean;
  cypherCode?: string;
  token?: string;
  session?: Partial<IsacSession>;
  basis?: Basis;
};

export const defaultState: StateType = {
  status: 'idle' as const,
  isLoggedIn: false,
  cypherCode: undefined,
  token: undefined,
  session: undefined,
  basis: undefined,
};

// Stato dell'utente
const stateSignal = signal<StateType>(defaultState);

const configurationSignal = signal<ConfigurationResponse | null>(null);

const filesSignal = signal<VirtualFileSystemType | null>(null);

// Stato delle impostazioni
const settingsState = signal({
  theme: 'light',
  notifications: true,
});

// Caricare lo stato dell'utente da localStorage al primo caricamento
if (typeof window !== 'undefined') {
  const token = LocalStorage.getItem('token');
  if (token) {
    stateSignal.value.token = token;
  }
}

const isLoggedIn = computed(() => {
  return !!stateSignal.value.isLoggedIn;
});

export {
  configurationSignal,
  filesSignal,
  isLoggedIn,
  settingsState,
  stateSignal,
};
